export default __webpack_public_path__ + "static/media/frame_overlay_far_green.37e72310.png";